import $ from 'jquery';
import Component from '../models/Component';
import {
  scrollTriggerSingleton,
  gsapSingleton
} from "../gsap";
import {
  $Win,
  $Doc
} from "../utils/jQueryGlobals";

const ScrollTrigger = scrollTriggerSingleton();
const gsap = gsapSingleton();

gsap.registerPlugin(ScrollTrigger);

export default class Menu extends Component {
  constructor(element, options = {}, context) {
    super(element, context);

    const defaultOptions = {
      enableMoveHeight: true,
      darkSectionSelector: null
    };

    this.options = {
      ...defaultOptions,
      ...options
    };


    this.$hamburger = $('.hamburger');
    this.$header = $('header');
    this.$menuItems = $('#menu-items');
    this.$htmlBody = $('html, body');
    this.$window = $(window);
    this.$body = $('body');
    
    this.isOpen = false;
    this.lastScrollTop = 0;
    this.darkSectionTriggers = [];
    this.isAnimating = false;

    $(() => {
      this.init();
    });
  }

  getHeroHeight() {
    const hero = document.querySelector('.hero-section');
    return hero ? hero.offsetHeight : 0;
  }

  isHomePage() {
    return this.$body.hasClass('home') || this.$body.hasClass('page-template-template-homepage-prova');
  }

  openMenu() {
    if (this.isOpen) return;
    this.isOpen = true;
    
    this.$hamburger.addClass('is-active');
    this.$menuItems.show();
    this.$htmlBody.addClass('open-menu no-scroll');

    // Animazione GSAP corretta per i menu items
    const titoliHeader = gsap.utils.toArray('.menu-item > a, #contact .button-cta_wrapper, .language-switcher > div');
    gsap.set(titoliHeader, { 
        y: '110%',
        opacity: 0 
    });
    
    gsap.to(titoliHeader, {
        y: '0%',
        opacity: 1,
        duration: 0.4,
        stagger: 0.05,
        ease: "power2.out"
    });

    // Disabilita i trigger delle sezioni scure quando il menu è aperto
    this.darkSectionTriggers.forEach(st => st.disable());
  }

  closeMenu() {
    if (!this.isOpen) return;
    this.isOpen = false;
    
    this.$hamburger.removeClass('is-active');
    this.$menuItems.hide();
    this.$htmlBody.removeClass('open-menu no-scroll');

    // Riabilita i trigger delle sezioni scure
    this.darkSectionTriggers.forEach(st => st.enable());
    ScrollTrigger.refresh();
    this.handleScroll();
  }

  setupToggle() {
    this.$hamburger.on('click', () => {
      if (this.isOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });
  }

  handleScroll() {
    if (this.isAnimating) return;

    const currentScrollTop = $Doc.scrollTop();

    if (this.isHomePage()) {
      const heroHeight = this.getHeroHeight();
      if (currentScrollTop < heroHeight / 2) {
        this.$header.removeClass('no-top');
      } else {
        this.$header.addClass('no-top');
      }
    }

    // Rimuove la logica move-height per mantenere il menu sempre visibile
    // Il menu sarà nascosto solo all'inizio della home page (gestito da no-top)
    this.$header.removeClass('move-height');
  }

  cleanupDarkSectionTriggers() {
    this.darkSectionTriggers.forEach(st => st.kill());
    this.darkSectionTriggers = [];
    this.$header.removeClass('dark-menu');
  }

  setupDarkSectionDetection() {
    this.cleanupDarkSectionTriggers();
    
    if (!this.options.darkSectionSelector) {
      return;
    }

    const darkSections = document.querySelectorAll(this.options.darkSectionSelector);
    const headerHeight = this.$header.outerHeight() || 100;

    if (darkSections.length > 0) {
      darkSections.forEach(section => {
        const st = ScrollTrigger.create({
          trigger: section,
          start: `top top+=${headerHeight}`,
          end: `bottom top+=${headerHeight}`,
          refreshPriority: -1,
          toggleClass: {
            targets: this.$header,
            className: "dark-menu"
          },
          markers: false 
        });
        this.darkSectionTriggers.push(st);
      });
    } else {
      console.warn(`Nessuna sezione trovata con il selettore "${this.options.darkSectionSelector}"`);
    }
  }

  setupScrollHandling() {
    this.$window.on('scroll', () => {
      if (!this.isOpen) {
        this.handleScroll();
      }
    });

    this.$window.on('resize', () => {
      this.handleScroll();
      if (this.options.darkSectionSelector) {
        this.setupDarkSectionDetection();
      }
      ScrollTrigger.refresh();
    });

    if (this.options.enableMoveHeight) {
      $Win.on('mousemove', (event) => {
        if (window.innerWidth > 1024) {
          if (event.clientY < 60) {
            this.$header.removeClass('move-height');
          }
        }
      });
    }
  }

  setupHomepageScrollTrigger() {
    if (!this.isHomePage()) return;

    ScrollTrigger.create({
      trigger: ".hero-section",
      start: "center top",
      onEnter: () => {
        this.isAnimating = true;
        this.$header.addClass('no-top').removeClass('move-height');
        
        gsap.delayedCall(1, () => {
          this.isAnimating = false;
          this.handleScroll();
        });
      },
      onLeaveBack: () => {
        this.$header.removeClass('no-top');
      }
    });
  }

  init() {
    this.$header.removeClass('move-height');
    this.setupToggle();
    this.setupScrollHandling();
    this.setupHomepageScrollTrigger();
    
    if (this.options.darkSectionSelector) {
      this.setupDarkSectionDetection();
    }
  }
}
